// extracted by mini-css-extract-plugin
module.exports = {"btn":"buttons_btn__U7-wu"};